import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://www.a1looks.com';
const DEFAULT_DESC =
  'Shop authentic Punjabi Juttis, Kundan jewellery, earrings, necklaces and ethnic accessories. Handcrafted by artisans, shipped across India.';
const DEFAULT_IMAGE = `${SITE_URL}/og-default.jpg`;

export default function SEOHead({
  title,
  description = DEFAULT_DESC,
  canonical,
  ogType = 'website',
  ogImage = DEFAULT_IMAGE,
  noindex = false,
  jsonLd,
}) {
  const pageTitle = title || 'A1 Looks — Traditional Punjabi Juttis & Ethnic Jewellery';
  const canonicalUrl = canonical || SITE_URL;

  const structuredData = jsonLd
    ? { '@context': 'https://schema.org', '@graph': Array.isArray(jsonLd) ? jsonLd : [jsonLd] }
    : null;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="A1 Looks" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD Structured Data */}
      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </Helmet>
  );
}
